<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Resources</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Blogs</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <modal
      :show.sync="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class=" overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div class="">
          <div class="flex justify-between items-center  pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              @click="editModal = false"
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </modal> -->
    <!-- v-for="(item, index) in 6" :key="index" -->
    <swiper-slide class="">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="../../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="flex justify-end h-95per">
        <img
          src="../../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="h-640px bg-white"
        />
      </div>
      <div
        class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32"
      >
        <!-- <img
          src="../../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
        /> -->
        <div class="lg:w-1/2 md:w-1/2 w-full">
          <div class="">
            <p
              class="font-semibold fsize48 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
            >
              Blogs
            </p>
            <p
              class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
            >
              A Caregivers’ knowledge source and guide for reliable insights
              penned by experts; get caregiving tips, learn well-being practices
              and more.
            </p>
          </div>
        </div>

        <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Resources/Blog-Banner.jpg"
            class="m-auto custborderradius mt-8 block lg:hidden md:hidden"
            alt=""
          />
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Resources/Blog-Banner.jpg"
            class="m-auto custborderradius md:block lg:block hidden"
            alt=""
          />
        </div>
      </div>
    </swiper-slide>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
      },
      editModal: false,
    };
  },
};
</script>
<style></style>
